import $ from "jquery";

$(function () {

    if ($('#controller-account, #controller-users.action-show').length === 0) {
        return
    }

    if ($('#add_another_email').length) {
        $('#another_email').hide()

        $('#add_another_email').on('click', function () {
            $(this).hide()
            $('#another_email').show()
        })

        $('#save_another_email').on('click', function () {
            $(this).closest('form').submit()
        })

        $('#cancel_another_email').on('click', function () {
            $(this).closest('form').find('input').val('')
            $('#another_email').hide()
            $('#add_another_email').show()
        })
    }

    if ($('#hits_per_day').length > 0) {
        // update_total_hits()
        update_chart()

        $('.select-for-total-hits-per-day').change(() => // update_total_hits()
            update_chart())

        $('.select-all-for-total-hits-per-day').change(function () {
            $('.select-for-total-hits-per-day').prop('checked', this.checked);
            update_chart();
        })
    }


    // Check for logo progress periodically
    if ($('#check_logo_progress').length) {

        var logo_check_interval = setInterval(() => $.getJSON($('#check_logo_progress a').attr('href'), function (data, status) {
                if (data.status === "finished") {
                    if (data.src) {
                        $('.logo img').attr("src", `${data.src}`)
                        $('#current_logo').attr("src", `${data.src}`)
                    }
                    $('#check_logo_progress').remove()
                    $('#remove_custom_logo').show()
                    clearInterval(logo_check_interval)
                }
            })
            , 2000)
    }

    // Direct uploads for logo and watermark are now handled by the
    // Stimulus `direct-upload` controller. The legacy jQuery-based
    // `#fileupload` handler has been removed to avoid duplicate bindings.
})

var update_chart = function () {

    let max = 0
    const datasets = []
    for (let variant of Array.from($('input.select-for-total-hits-per-day:checked, input.select-all-for-total-hits-per-day:checked'))) {

        const _max = Math.max.apply(null, $(variant).data('chart'))
        if (_max > max) {
            max = _max
        }

        datasets.push({
            fillColor: `rgba(${$(variant).data('color')},0.05)`,
            strokeColor: `rgba(${$(variant).data('color')},1)`,
            pointColor: `rgba(${$(variant).data('color')},1)`,
            pointStrokeColor: "#fff",
            data: $(variant).data('chart')
        })
    }

    const data = {
        labels: $('#hits_per_day').data('labels'),
        datasets
    }

    if (max < 10) {
        max = 10
    }
    const steps = 20
    const step_width = Math.round((max * 1.0) / steps)

    const options = {
        scaleOverride: true,
        scaleSteps: steps + 2,
        scaleStepWidth: step_width,
        scaleStartValue: 0
    }

    const parent = $("#hits_per_day").parent()
    const labels = $("#hits_per_day").data('labels')
    $("#hits_per_day").remove()
    const canvas = $('<canvas id="hits_per_day" width="' + parent.width() + '" height="' + ((parent.width() / 3.0) * 2.0) + '"></canvas>')
    canvas.data('labels', labels)
    parent.append(canvas)

    // Get context with jQuery - using jQuery's .get() method.
    const ctx = canvas.get(0).getContext("2d")
    new Chart(ctx).Line(data, options)
};
